export default __webpack_public_path__ + "static/media/fsw_1.2c2c2d1b.png";